import './plugins/jquery-2.2.4.min';
window.Handlebars = require("handlebars");
window.axios = require('axios');

// Main
import './plugins/bootstrap.min';
//import './plugins/bootstrap-extra.min';

// jQuery
import './plugins/jquery.tmpl.min';
import './plugins/jquery.serialScroll.min';
import './plugins/jquery.history.min';
import './plugins/jquery.mmenu.min.all';

// Others
import './plugins/fastclick.min';